var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPlanMat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 34,
    viewBox: "0 0 124 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.6575,
    height: 33,
    transform: "translate(0.508545 0.5)",
    fill: "#303F9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6421 25.8664V12.5264H57.8311C58.4444 12.5264 59.0041 12.6797 59.5101 12.9864C60.0161 13.293 60.4148 13.6994 60.7061 14.2054C61.0128 14.7114 61.1661 15.2634 61.1661 15.8614V25.8664H57.6471V16.0454H51.1611V25.8664H47.6421Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7635 25.8664C34.1501 25.8664 33.5905 25.713 33.0845 25.4064C32.5785 25.0997 32.1721 24.6934 31.8655 24.1874C31.5741 23.6814 31.4285 23.1294 31.4285 22.5314V17.4254H41.4335V16.0454H31.4285V12.5264H41.6175C42.2308 12.5264 42.7905 12.6797 43.2965 12.9864C43.8025 13.293 44.2011 13.6994 44.4925 14.2054C44.7991 14.7114 44.9525 15.2634 44.9525 15.8614V25.8664H34.7635ZM34.9475 22.3474H41.4335V20.5074H34.9475V22.3474Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.345 25.8663C25.747 25.8663 25.195 25.713 24.689 25.4063C24.183 25.0996 23.7767 24.6933 23.47 24.1873C23.1633 23.6813 23.01 23.1293 23.01 22.5313V8.1333H26.552V22.3473H29.243V25.8663H26.345Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50854 25.8661V9.3291H17.6415C18.2702 9.3291 18.8375 9.48243 19.3435 9.7891C19.8649 10.0958 20.2789 10.5098 20.5855 11.0311C20.9075 11.5524 21.0685 12.1198 21.0685 12.7331V17.0111C21.0685 17.6244 20.9075 18.1918 20.5855 18.7131C20.2789 19.2344 19.8649 19.6484 19.3435 19.9551C18.8375 20.2618 18.2702 20.4151 17.6415 20.4151L8.07354 20.4381V25.8661H4.50854ZM8.07354 16.8271H17.4575V12.8941H8.07354V16.8271Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56.2553,
    height: 33,
    transform: "translate(67.166 0.5)",
    fill: "#1DE9B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.093 26.0241C113.453 26.0241 112.869 25.8641 112.341 25.5441C111.813 25.2241 111.389 24.8001 111.069 24.2721C110.749 23.7441 110.589 23.1681 110.589 22.5441V7.97607H114.261V12.1041H119.421V15.7761H114.261V22.3521H119.421V26.0241H114.093Z",
    fill: "#2537A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9812 26.024C96.3412 26.024 95.7572 25.864 95.2292 25.544C94.7012 25.224 94.2772 24.8 93.9572 24.272C93.6532 23.744 93.5012 23.168 93.5012 22.544V17.216H103.941V15.776H93.5012V12.104H104.133C104.773 12.104 105.357 12.264 105.885 12.584C106.413 12.904 106.829 13.328 107.133 13.856C107.453 14.384 107.613 14.96 107.613 15.584V26.024H96.9812ZM97.1732 22.352H103.941V20.432H97.1732V22.352Z",
    fill: "#2537A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.166 26.0241V8.74414H75.006L80.862 15.7281L86.694 8.74414H90.558V26.0241H86.814V14.4321L80.862 21.5361L74.886 14.4561V26.0241H71.166Z",
    fill: "#2537A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlanMat);
export default __webpack_public_path__ + "static/media/logo-plan-mat.92a702514a6dd9923a5e83e5e1bb884c.svg";
export { ForwardRef as ReactComponent };